import { Button } from "@workspace/web-ui/components/button";
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@workspace/web-ui/components/form";

import { Allergy } from "../../types";

import { Input } from "@workspace/web-ui/components/input";
import { useAllergy } from "../../hooks/use-allergy";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select";

interface AllergyFormProps {
    allergy?: Allergy | null;
    onClose?: () => void;
}

export const AllergyForm = ({ allergy, onClose }: AllergyFormProps) => {
    const { form, onSubmit, isLoading } = useAllergy({ allergy, onClose });

    return (
        <Form {...form}>
            <form
                onSubmit={form.handleSubmit(onSubmit)}
                className="space-y-4"
                aria-label={allergy ? "Update Allergy Form" : "Add Allergy Form"}
            >
                <FormField
                    control={form.control}
                    name="name"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel htmlFor="name">What are you allergic to?</FormLabel>
                            <FormControl>
                                <Input
                                    id="name"
                                    className="w-full"
                                    placeholder="Enter an allergy"
                                    aria-label="Name"
                                    aria-required="true"
                                    {...field}
                                />
                            </FormControl>
                            <FormMessage role="alert" />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="severity"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel htmlFor="severity">Severity</FormLabel>
                            <FormControl>
                                <Select onValueChange={field.onChange} defaultValue={field.value}>
                                    <FormControl>
                                        <SelectTrigger>
                                            <SelectValue placeholder="Select a severity" />
                                        </SelectTrigger>
                                    </FormControl>
                                    <SelectContent>
                                        <SelectItem value="Mild">Mild</SelectItem>
                                        <SelectItem value="Moderate">Moderate</SelectItem>
                                        <SelectItem value="Severe">Severe</SelectItem>
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage role="alert" />
                        </FormItem>
                    )}
                />
                <div className="flex items-center w-full justify-end gap-2">
                    <Button
                        className="transition-colors rounded-[8px] bg-[#4272DD] w-full duration-200 "
                        type="submit"
                        disabled={isLoading}
                        aria-busy={isLoading}
                    >
                        {isLoading ? allergy ? "Updating..." : "Saving..." : "Save"}
                    </Button>
                </div>
            </form>
        </Form>
    );
};
